import SwellSubscriptions from './SwellSubscriptions';

export default {
    mixins: [SwellSubscriptions],

    data() {
        return {
            planForm: new Form({
                locations_limit: this.team.locations_limit,
                plan: '',
            })
        }
    },

    computed: {
        urlForPlanUpdate() {
            return this.$laroute.route('api.teams.update-subscription', {
                team: this.team.id
            });
        },

        changedPlan() {
            return this.selectedPlan
                && this.activePlan.id !== this.selectedPlan.id
                || this.planForm.locations_limit !== this.team.locations_limit;
        },

        selectedPlan() {
            return this.planForm.plan && this.plans.find(p => p.id === this.planForm.plan);
        },

        deprecatedPlan() {
            return this.activePlan && !this.plans.includes(this.activePlan);
        },
    },

    methods: {
        afterFetchPlans() {
            this.planForm.plan = this.activePlan.id;
        },

        selectPlan(plan) {
            this.selectingPlan = plan;
        },

        confirmUpdate() {
            this.$refs.confirm.open();
        },

        update() {
            return this.planForm.put(this.$laroute.route('api.teams.update-subscription', { team: this.team.id }))
                .then(() => {
                    Bus.$emit('updateUser');
                    Bus.$emit('updateTeam');
                    this.$refs.confirm.close();
                })
                .catch(response => {
                    if (response.status !== 422) {
                        this.planForm.errors.set({
                            plan: ['We were unable to update your subscription. Please contact customer support.']
                        });
                    }
                });
        },
    },
}
